import { useEffect, useState } from 'react';
import { putIntroduction } from '../../../apis/profile.api';
import { handleCheckChangeForm } from '../../../common/checkForm';
import { handleSubmitForm } from '../../../common/formCallApi';
import useToast from '../../useToast';

const useUpdateBusinessInfo = (
  defaultData: { name: string; description: string },
  open: boolean
) => {
  const [name, setName] = useState<string>(defaultData.name);
  const [description, setDescription] = useState<string>(
    defaultData.description
  );
  const [openConfirmClose, setOpenConfirmClose] = useState(false);

  const toast = useToast();

  const handleSubmitInfo = (cb: () => void) => {
    handleSubmitForm({
      data: { fullName: name, bio: description },
      requiredKeys: ['fullName'],
      asyncFunc: putIntroduction,
      formCancelCallBack: () => {},
      toggleSuccessModalNoti: () => {
        toast('Cập nhật thông tin thành công.', 'success');
        cb();
      },
      toggleErrorModalNoti: () => {
        toast('Cập nhật thông tin thất bại.', 'error');
      },
      callback: () => {},
      id: '',
      setLoading: () => {},
    });
  };

  const handleCloseModal = (cb: () => void) => {
    if (!handleCheckChangeForm({ name, description }, defaultData)) {
      setOpenConfirmClose(true);
      return;
    }
    cb();
  };

  useEffect(() => {
    if (open) {
      setName(defaultData.name);
      setDescription(defaultData.description);
      setOpenConfirmClose(false);
      toast('', 'error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return {
    name,
    setName,
    description,
    setDescription,
    handleSubmitInfo,
    handleCloseModal,
    setOpenConfirmClose,
    openConfirmClose,
  };
};

export default useUpdateBusinessInfo;
